export class InstitutionSetupModel {
    hasAnnualTerm:boolean;
    hasCampusLabsAdmin: boolean;
    hasInitializedAnnualTerm: boolean;
    hasInitializedOutcomesOrgTree: boolean;
    hasValidCommonsOrgUnit: boolean;

    constructor() {
        this.hasAnnualTerm = false;
        this.hasCampusLabsAdmin = false;
        this.hasInitializedAnnualTerm = false;
        this.hasInitializedOutcomesOrgTree = false;
        this.hasValidCommonsOrgUnit = false;
    }
}


/** WEBPACK FOOTER **
 ** ./app/readiness/models/InstitutionSetupModel.ts
 **/